// Utils
import { getDataType } from '../../attachments/attachmentsSelector';
import { getFileType } from '../../../../common/elements/utils/elementPropertyUtils';
import { fileTypeSupportsPreviews } from '../../../../common/files/filePreviewUtils';

export default (element, attachment) => {
    const fileType = getFileType(element) || getDataType(attachment);
    return fileTypeSupportsPreviews(fileType);
};
